import { ActorMergeSearchKey } from "../actions/actorMergeActions";

export const actorMergeSearchResultsSelector = (key: ActorMergeSearchKey) => (state: RootState) =>
    state.actorMerge.searchByKey[key].results;

export const actorMergeSearchLoadingSelector = (key: ActorMergeSearchKey) => (state: RootState) =>
    state.actorMerge.searchByKey[key].loading;

export const actorMergeSearchErrorSelector = (key: ActorMergeSearchKey) => (state: RootState) =>
    state.actorMerge.searchByKey[key].error;

export const actorMergeActorDetailsSelector = (actorId: number | null | undefined) => (state: RootState) => {
    if (actorId == null) return null;
    return state.actorMerge.detailsById[actorId] ?? null;
};

export const actorMergeActorDetailsLoadingSelector = (actorId: number | null | undefined) => (state: RootState) => {
    if (actorId == null) return false;
    return state.actorMerge.detailsLoadingById[actorId] ?? false;
};

export const actorMergeActorDetailsErrorSelector = (actorId: number | null | undefined) => (state: RootState) => {
    if (actorId == null) return null;
    return state.actorMerge.detailsErrorById[actorId] ?? null;
};
